import React from "react";
import flowers from "../data/buchetePremium";
import FlowerContainer from "../components/FlowerContainer";

const BuchetePremium = () => {
  return (
    <FlowerContainer
      flowers={flowers}
      title="Buchete Premium"
      subtitle="Descoperă selecția noastră de buchete premium, create pentru a impresiona."
      storageKey="BUCHETE_PREMIUM_SCROLL_POSITION"
    />
  );
};

export default BuchetePremium;
